var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "vote" }, [
    _c("p", { staticClass: "vote__label" }, [
      _vm._v("\n    " + _vm._s(_vm.label) + ":\n  ")
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "vote__wrap" }, [
      _c("div", { staticClass: "vote__up" }, [
        _c(
          "button",
          {
            staticClass: "vote__button vote__button--up",
            class: { "vote__button--voted": _vm.hasVotedUp },
            on: { click: _vm.onVoteUp }
          },
          [
            _c("span", { staticClass: "sr-only" }, [
              _vm._v(_vm._s(_vm.upVoteText))
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "vote__print-text" }, [
              _vm._v("\n          +\n        ")
            ])
          ]
        ),
        _vm._v(" "),
        _c("span", { staticClass: "vote__score" }, [
          _vm._v("\n        " + _vm._s(_vm.scoreUp) + "\n      ")
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "vote__down" }, [
        _c("span", { staticClass: "vote__score" }, [
          _vm._v("\n        " + _vm._s(_vm.scoreDown) + "\n      ")
        ]),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "vote__button vote__button--down",
            class: { "vote__button--voted": _vm.hasVotedDown },
            on: { click: _vm.onVoteDown }
          },
          [
            _c("span", { staticClass: "sr-only" }, [
              _vm._v(_vm._s(_vm.downVoteText))
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "vote__print-text" }, [
              _vm._v("\n          -\n        ")
            ])
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }